export enum Size {
  Small = 'sm',
  Medium = 'm',
  Large = 'lg',
}
